// extracted by mini-css-extract-plugin
export var bodySections = "_e1-8";
export var gray = "_e1-7";
export var green = "_e1-4";
export var iconContainer = "_e1-9";
export var iconWidgetContainer = "_e1-1";
export var phoneIcon = "_e1-2";
export var red = "_e1-5";
export var statusDot = "_e1-3";
export var widgetContainer = "_e1-0";
export var yellow = "_e1-6";